import { render, staticRenderFns } from "./EmployeeBankInfo.vue?vue&type=template&id=4ad561ac"
import script from "./EmployeeBankInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeBankInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports